import { useIsCommandCenter } from 'components/MapPage/CorporateViewTabs/LayersTab/utils/isCommandCenter';
import { selectIncident, useAppSelector } from 'slices/commonSelectors';

/**
 * Incident attached to this chat turn. On the hub / command center, Redux still
 * holds the last (or first) incident in the org — that must not become the
 * default PRATUS AI scope. Inside `/iap/:incidentId` (or any non-hub route) the
 * selected incident is the workspace and is returned as-is.
 */
export const useAiWorkspaceIncident = (): IncidentAugmented | undefined => {
  const incident = useAppSelector(selectIncident);
  const isCommandCenter = useIsCommandCenter();
  if (isCommandCenter || !incident?.id) return undefined;
  return incident;
};
